/**
 * PURPOSE: represents the business line appetite options as an enum
 */
export enum BusinessLineAppetiteEnum {
  EXCLUDED = "EXCLUDED",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED"
}
